import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { XLarge } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import addClass from '../../utils/dom/addClass';
import css from './VideoPreviewer.module.scss';
import Play from '../icons/Play';
import removeClass from '../../utils/dom/removeClass';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NO_SCROLL = 'no-scroll';

var hideSubtitles = function hideSubtitles(vidRef) {
  if (!vidRef || !vidRef.current) {
    return;
  }

  for (var i = 0; i < vidRef.current.textTracks.length; i++) {
    // eslint-disable-line
    vidRef.current.textTracks[i].mode = 'hidden'; // eslint-disable-line
  }
};

var VideoPreviewer = function VideoPreviewer(_ref) {
  var fullVideoCaptions = _ref.fullVideoCaptions,
      fullVideoSrc = _ref.fullVideoSrc,
      fullVideoDescription = _ref.fullVideoDescription,
      previewPoster = _ref.previewPoster,
      previewSrc = _ref.previewSrc,
      previewTrack = _ref.previewTrack,
      title = _ref.title;
  var fullVideo = /*#__PURE__*/React.createRef();
  var shortVideo = /*#__PURE__*/React.createRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showVideo = _useState2[0],
      setShowVideo = _useState2[1];

  var openVideo = function openVideo() {
    addClass(document.body, NO_SCROLL);
    setShowVideo(true);

    if (fullVideo && fullVideo.current) {
      fullVideo.current.play();
    }
  };

  var closeVideo = useCallback(function () {
    removeClass(document.body, NO_SCROLL);
    setShowVideo(false);

    if (fullVideo && fullVideo.current) {
      fullVideo.current.pause();
    }
  });
  useEffect(function () {
    var onClick = function onClick(_ref2) {
      var target = _ref2.target;

      if (fullVideo && fullVideo.current && fullVideo.current.contains(target)) {
        return;
      }

      closeVideo();
    };

    if (showVideo) {
      document.addEventListener('click', onClick);
    } else {
      document.removeEventListener('click', onClick);
    }

    hideSubtitles(fullVideo);
    hideSubtitles(shortVideo);
    return function () {
      document.removeEventListener('click', onClick);
    };
  }, [closeVideo, fullVideo, showVideo, shortVideo]);
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("video", {
      autoPlay: true,
      className: css.preview,
      controls: false,
      controlsList: "nodownload",
      crossOrigin: "anonymous",
      loop: true,
      muted: true,
      playsInline: true,
      preload: "metadata",
      poster: previewPoster,
      ref: shortVideo,
      children: [/*#__PURE__*/_jsx("source", {
        src: previewSrc,
        type: "video/mp4"
      }), previewTrack && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("track", {
          label: "english_description",
          kind: "descriptions",
          srcLang: "en",
          src: previewTrack
        }), /*#__PURE__*/_jsx("track", {
          label: "english_captions",
          kind: "captions",
          srcLang: "en",
          src: previewTrack,
          default: true
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.center,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("button", {
        className: css.playButton,
        onClick: openVideo,
        type: "button",
        title: "Video Play Button",
        children: /*#__PURE__*/_jsx(Play, {})
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: cc([css.videoBox, _defineProperty({}, css.showVideoBox, showVideo)]),
      children: [/*#__PURE__*/_jsx("button", {
        className: css.closeButton,
        onClick: closeVideo,
        type: "button",
        title: "Video Close Button",
        children: /*#__PURE__*/_jsx(XLarge, {})
      }), /*#__PURE__*/_jsxs("video", {
        className: css.video,
        controls: true,
        controlsList: "nodownload",
        crossOrigin: "anonymous",
        preload: "metadata",
        ref: fullVideo,
        children: [/*#__PURE__*/_jsx("source", {
          src: fullVideoSrc,
          type: "video/mp4"
        }), fullVideoDescription && /*#__PURE__*/_jsx("track", {
          label: "english_description",
          kind: "descriptions",
          srcLang: "en",
          src: fullVideoDescription
        }), fullVideoCaptions && /*#__PURE__*/_jsx("track", {
          label: "english_captions",
          kind: "captions",
          srcLang: "en",
          src: fullVideoCaptions,
          default: true
        })]
      })]
    })]
  });
};

VideoPreviewer.defaultProps = {
  fullVideoCaptions: false,
  fullVideoDescription: false,
  previewTrack: false
};
VideoPreviewer.propTypes = {
  fullVideoCaptions: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fullVideoSrc: PropTypes.string.isRequired,
  fullVideoDescription: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  previewPoster: PropTypes.string.isRequired,
  previewSrc: PropTypes.string.isRequired,
  previewTrack: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string.isRequired
};
export default VideoPreviewer;